module.exports = __webpack_public_path__ + "img/账号@2x.49bdaece.png";